"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgHome = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M17 35a3 3 0 01-3-3V21a1 1 0 01.386-.79l9-7a1 1 0 011.228 0l9 7A1 1 0 0134 21v11a3 3 0 01-3 3H17zm7-19.733l-8 6.222V32a1 1 0 001 1l3-.001V24a1 1 0 011-1h6a1 1 0 011 1v8.999L31 33a1 1 0 001-1V21.49l-8-6.223zM26 25h-4v7.999h4V25z",
    id: "home_svg__a"
  }));
};

var _default = SvgHome;
exports.default = _default;